"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
/**
 * Thrown when valid url elements are missing
 * @param {string} protocol
 * @param {string} host
 * @param {string} path
 */
class UrlConstructionError extends ExtendableError_1.default {
    constructor(protocol, host, path) {
        super(`Invalid URL components - protocol:${protocol},` +
            `host:${host}, path: ${path}`);
    }
}
exports.default = UrlConstructionError;
